<template>
	<div class="checkbox-container mode-checkbox">
		<input
			:id="radioId"
			v-model="innerValue"
			:name="name"
			:value="radioValue"
			type="radio"
			@input="$emit('input', $event.target.value)"
		>
		<label :for="radioId" class="checkbox-checkmark" />
		<label :for="radioId" class="pointer">{{ label }}</label>
	</div>
</template>

<script>
import { uniqueKey } from '~/assets/util/helpers'

export default {
	name: 'Radio',
	props: {
		value: {
			type: [String, Number],
			required: false,
			default: ''
		},
		radioValue: {
			type: [String, Number],
			default: ''
		},
		name: {
			type: String,
			required: true
		},
		label: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			radioId: uniqueKey(),
			innerValue: ''
		}
	},
	watch: {
		value: {
			immediate: true,
			handler (val) {
				this.innerValue = val
			}
		}
	}
}
</script>
